import { useEffect, useState } from "react";
import useGet from "../useGet";
import useBranchPeople from "../useBranchPeople";
import { MoneyCorpPermissions } from "../usePermissions/usePermissions";

const useBranch = (
  companyId: string | undefined,
  branchId: number | undefined,
  permissions: MoneyCorpPermissions,
  userChangeCount: number,
  branchChangeCount: number
) => {
  const [branch, setBranch] = useState<any>();
  const selectedBranchReturn = useGet(
    `/api/Companies/${companyId}/Branches/${branchId}?ts=` +
      new Date().getTime(),
    `Unable to read branch '${branchId}' for company id '${companyId}'`,
    null,
    [companyId, branchId, userChangeCount, branchChangeCount],
    undefined,
    () => companyId != null && companyId !== "" && branchId != null
  );

  const { branchPeople } = useBranchPeople(companyId, branchId, permissions, [
    userChangeCount,
    branchChangeCount
  ]);

  useEffect(() => {
    setBranch(
      selectedBranchReturn.value && branchId
        ? { ...selectedBranchReturn.value, customers: branchPeople }
        : null
    );
  }, [selectedBranchReturn.value, branchId, branchPeople]);

  return {
    branch,
    branchLoading: selectedBranchReturn.loading
  };
};

export default useBranch;
